import { NAVIGATION } from 'Config';
import styles from './Home.module.css';

const BOSFooter = () => {
  const getExtLinkButton = (link) => {
    return (
      <a
        key={link.url}
        className={styles.footer_links}
        href={link.url}
        target='_blank'
        rel='noreferrer'>
        {link.title}
      </a>
    );
  };

  let extLinks = NAVIGATION.homePageExternalLinks.map(getExtLinkButton);

  return <div className={styles.bos_footer}>{extLinks}</div>;
};

export default BOSFooter;
